export default __webpack_public_path__ + "static/media/Easy.33912072.png";